const defaultRoutes = [{
  title: 'Home',
  path: '/home',
  show: true
}, {
  title: 'Trips',
  path: '/trips',
  show: true
}, {
  title: 'Timeline',
  path: '/timeline',
  show: true
}, {
  title: 'History',
  path: '/history',
  show: true
},
{
  title: 'Reports',
  path: '/reports',
  show: true
},
{
  title: 'Live View',
  path: '/all-tracker',
  show: true
},
{
  title: 'Compliance',
  path: '/advance-analytics',
  show: true
}
]
const defaultDashboardRoutes = [
  {
    // title: 'Home',
    path: '/load-optimizer',
    dashboard_url: 'https://packer.searates.com/services/online/stuffing/?lang=en'
  },
  {
    path: '/epod',
    dashboard_url: 'https://epod.intutrack.com/#/home?hide_toolbar=true',
    generate_token: true
  },
  {
    path: '/analytics',
    dashboard_url: 'https://analytics.sct.intutrack.com/iframe',
    token_required: true
  }
]
const formatRoutes = (routes) => {
  const uniquePaths = new Set(); // To track unique paths
  const dropdown_headers = []; // To track dropdown headers

  // First, process routes to create dropdown structure
  let processedRoutes = routes.map((route) => {
    if (route?.dropdown_header && dropdown_headers.indexOf(route.dropdown_header) <= -1) {
      dropdown_headers.push(route.dropdown_header);
      let temp_route = {
        title: route.dropdown_header,
        path: route.dropdown_header,
        show: true,
        dropdown: true,
        dropdown_items: routes.filter(item => item.dropdown_header === route.dropdown_header)
      };
      return temp_route;
    } else if (!route?.dropdown_header) {
      return route;
    }
    return null; // Filter out routes that are part of dropdown but not the header
  }).filter(route => route); // Remove null entries

  // Now format the routes
  return processedRoutes.filter((route) => {
    if (route.show && !uniquePaths.has(route.path)) {
      uniquePaths.add(route.path); // Add path to the set
      return true; // Keep this route
    }
    return false; // Filter out duplicates
  }).map((route, index) => {
    // Handle dropdown routes
    if (route.dropdown) {
      const dropdown_items = route.dropdown_items.map((item) => {
        let id = item.path.toLowerCase().replace(/ /g, '-');
        const route_path = item.path.toString().split('/');
        let path = item.path.toString();

        if (route_path.length > 1 && route_path[1] === 'page') {
          id = route_path[1];
          path = "/page?id=" + route_path[2];
        }

        return {
          id: item?.title?.toLowerCase().replace(/ /g, '-'),
          path: path,
          label: item.title.toUpperCase().replace(/ /g, '-'),
          moduleName: item.title.toUpperCase(),
          ...(item.dashboard_url ? { dashboard_url: item.dashboard_url } : {}),
          ...(item.generate_token ? { generate_token: item.generate_token } : {}),
          ...(item.auth_token ? { auth_token: item.auth_token } : {}),
          ...(item.token_required ? { token_required: item.token_required } : {}),
        };
      });

      return {
        id: route?.title?.toLowerCase().replace(/ /g, '-'),
        path: route.path,
        label: route.title.toUpperCase().replace(/ /g, '-'),
        moduleName: route.title.toUpperCase(),
        dropdown: true,
        dropdown_items: dropdown_items
      };
    }

    // Handle regular routes
    let id = route.path.toLowerCase().replace(/ /g, '-');
    const route_path = route.path.toString().split('/');
    let path = route.path.toString();

    if (route_path.length > 1 && route_path[1] === 'page') {
      id = route_path[1];
      path = "/page?id=" + route_path[2];
    }

    return {
      id: route?.title?.toLowerCase().replace(/ /g, '-'),
      path: path,
      label: route.title.toUpperCase().replace(/ /g, '-'),
      moduleName: route.title.toUpperCase(),
      ...(route.dashboard_url ? { dashboard_url: route.dashboard_url } : {}),
      ...(route.generate_token ? { generate_token: route.generate_token } : {}),
      ...(route.auth_token ? { auth_token: route.auth_token } : {}),
      ...(route.token_required ? { token_required: route.token_required } : {}),
    };
  });
}

const setStaticRoutes = (navigationItems, config = {}) => {
  defaultDashboardRoutes.forEach((route) => {
    let index = navigationItems.findIndex((item) => item.path === route.path)
    if (index > -1) {
      let item = { ...navigationItems[index] }
      item.path = "/page?id=" + route.path.replace("/", "")
      item.dashboard_url = route.dashboard_url
      item.generate_token = route?.generate_token ? true : false
      item.token_required = route?.token_required ? true : false
      if (route.path.match(/epod/)) {
        item.auth_token = config?.epod_stuff?.API_KEY
      }

      navigationItems[index] = item
    }
    else {
      navigationItems.push(route)
    }
  })
  return navigationItems
}

const setRoutes = (navigationItems, config = {}) => {
  if (config?.navbar_headers_field?.length) {
    navigationItems = config.navbar_headers_field
  }
  else if (config?.modules?.OPTED_FOR?.length && !config?.navbar_headers_field?.length) {
    // adding dynamic routes for modules
    config.modules.OPTED_FOR.forEach((module) => {
      if (config.modules[module]?.FRONTEND?.NAV) {
        let temp_route = {
          ...config.modules[module]?.FRONTEND?.NAV,
          title: config.modules[module]?.FRONTEND?.NAV?.title,
          path: "/page?id=" + module,
          show: true
        }
        navigationItems.push(temp_route)
        // navigationItems.push(Object.assign(config.modules[module].FRONTEND.NAV, { "show": true }))
      }
    })
  }
  if (config?.extra_headers?.length && !config?.navbar_headers_field?.length)
    navigationItems.push(...config.extra_headers)

  if (config?.epod_enabled && !config?.navbar_headers_field?.length) {
    navigationItems.push({
      title: 'EPOD',
      path: '/epod',
      show: true
    })
  }
  if (config?.consent_page && !config?.navbar_headers_field?.length) {
    navigationItems.push({
      title: 'Consent',
      path: '/consents',
      show: true
    })
  }
  if (config?.show_pages?.length && !config?.navbar_headers_field?.length) {
    navigationItems = navigationItems.filter((item) => config.show_pages.includes(item.path))
  }
  return setStaticRoutes([...navigationItems], config)
}
export const getRoutes = (config = {}) => {
  let tempRoutes = [...defaultRoutes]
  let navigationItems = setRoutes(tempRoutes, config)
  return formatRoutes(navigationItems)
}